import React from "react";
import propTypes from "prop-types";
import { Button, Col, Modal, Row, theme, Collapse } from "antd";
import { PRODUCT_TYPE, REPORT_FILTER } from "../constants/string";
import { URL_REPORT } from "../constants/urls";
import ReportModal from "../components/reports/ReportModal";
import Lottie from "lottie-react";
import lottieReport from "../asset/lottie_report.json"

export default function ReportView(props) {
  const [targetReport, setTargetReport] = React.useState(null);
  const [loading, setLoading] = React.useState(null);
  const [items, setItems] = React.useState([]);

  const {
		token: { colorInfoText }
	} = theme.useToken();

  const latexReports = [
    {
      id: 1, 
      label: "1. รายงานข้อมูลน้ำยางสดประจำวัน", 
      detail: "รายงานข้อมูลน้ำยางสดประจำวัน",
      filters: [{ name: REPORT_FILTER.DATE_RANGE, placeholder: "วันที่", required: true }],
      url: URL_REPORT.DAILY_RAW_LATEX
    },
    {
      id: 2, 
      label: "2. ผู้ขายเปรียบเทียบวันที่ส่งกับปริมาณน้ำยางสด", 
      detail: "รายงานผู้ขายน้ำยางสดเปรียบเทียบจำนวนวันที่ส่งกับปริมาณน้ำยางสดทั้งเดือน",
      filters: [{ name: REPORT_FILTER.MONTH, placeholder: "เดือน", required: true }],
      url: URL_REPORT.RAW_LATEX_IMPORT_CUSTOMER_MONTHLY
    },
    {
      id: 3, 
      label: "3. เปรียบเทียบประเภทรถและปริมาณน้ำยางสด", 
      detail: "รายงานเปรียบเทียบประเภทรถและปริมาณน้ำยางสด ประจำเดือน",
      filters: [{ name: REPORT_FILTER.MONTH, placeholder: "เดือน", required: true }],
      url: URL_REPORT.TRUCK_TYPE_RAW_LATEX_MONTHLY,
      hidePDF : true,
    },
    {
      id: 4, 
      label: "4. รายงานข้อมูลน้ำยางสดที่ไม่เข้าเงื่อนไขการรับซื้อ", 
      detail: "รายงานข้อมูลน้ำยางสดที่ไม่เข้าเงื่อนไขการรับซื้อ",
      filters: [{ name: REPORT_FILTER.DATE_RANGE, placeholder: "ช่วงวันที่", required: true }],
      url: URL_REPORT.TRUCK_REJECT_ENTRY,
    },
  ]

  const conLatexReports = [
    {
      id: 1, 
      label: "1. บันทึกยอดคงเหลือน้ำยางข้นในแต่ละแทงก์", 
      detail: "รายงานบันทึกยอดคงเหลือน้ำยางข้นในแต่ละแทงก์",
      filters: [{ name: REPORT_FILTER.TABLE_TANK_TRANSACTION, required: true }],
      pathUrl: REPORT_FILTER.TANK_TRANSACTION,
      url: URL_REPORT.REMAINING_TANK_WEIGHT,
      hidePDF : true,
      hideExcel : true,
    },
    {
      id: 2, 
      label: "2. รายงานยอดคงเหลือน้ำยางข้นประจำวัน", 
      detail: "รายงานยอดคงเหลือน้ำยางข้นประจำวัน",
      filters: [],
      url: URL_REPORT.PRODUCE_CONCENTRATED_LATEX_DAILY,
    },
  ]

  const skimReports = [
    {
      id: 1, 
      label: "1. รายงานบันทึกผลิตสกิม", 
      detail: "รายงานบันทึกผลิตสกิม",
      filters: [{ name: REPORT_FILTER.DATE_RANGE, placeholder: "ช่วงวันที่", required: true }],
      url: URL_REPORT.SKIM_PRODUCE_TRANSACTION,
      hidePDF: true
    },
    {
      id: 2, 
      label: "2. รายงานผลิตสกิมรายเดือน", 
      detail: "รายงานผลิตสกิมรายเดือน",
      filters: [{ name: REPORT_FILTER.MONTH, placeholder: "เดือน", required: true }],
      url: URL_REPORT.SKIM_PRODUCE_MONTHLY,
      hidePDF: true,
    },
    {
      id: 3, 
      label: "3. รายงานรับจ่ายเคมีภัณฑ์สกิม", 
      detail: "รายงานรับจ่ายเคมีภัณฑ์สกิม",
      filters: [
        { name: REPORT_FILTER.SKIM_CHEMICAL, placeholder: "สารเคมีสกิม", required: true },
        { name: REPORT_FILTER.MONTH, placeholder: "เดือน", required: true },
      ],
      pathUrl: REPORT_FILTER.SKIM_CHEMICAL,
      url: URL_REPORT.SKIM_CHEMICAL_USE,
    },
    {
      id: 4, 
      label: "4. ยอดการผลิตสกิม", 
      detail: "ยอดการผลิตสกิม",
      filters: [
        { name: REPORT_FILTER.DATE, placeholder: "วันที่", required: true },
      ],
      url: URL_REPORT.SKIM_PRODUCE,
    },
  ]

  const labReports = [
    {
      id: 1, 
      label: "1. รายงานแล็บบ่อพักน้ำยางสด", 
      detail: "รายงานแล็บบ่อพักน้ำยางสด",
      filters: [{ name: REPORT_FILTER.DATE_RANGE, placeholder: "ช่วงวันที่", required: true }],
      url: URL_REPORT.POND_LATEX_LAB_ORDER,
    },
  ]

  const saleReports = [
    {
      id: 1, 
      label: "1. รายงานสั่งซื้อน้ำยางข้น", 
      detail: "รายงานสั่งซื้อน้ำยางข้น",
      filters: [{ name: REPORT_FILTER.TABLE_SALE_ORDER, placeholder: "รายการสั่งซื้อน้ำยางข้น", required: true }],
      url: URL_REPORT.CONCENTRATE_LATEX_SALE_ORDER,
      hidePDF : true,
      hideExcel : true,
    },
    {
      id: 2, 
      label: "2. ใบแจ้งการผลิตน้ำยางข้น", 
      detail: "ใบแจ้งการผลิตน้ำยางข้น",
      filters: [
        { name: REPORT_FILTER.DATE, placeholder: "วันที่แจ้งผลิต", required: true },
        { name: REPORT_FILTER.NO, placeholder: "เลขที่", required: false },
      ],
      url: URL_REPORT.PRODUCE_ORDER,
      params: {type : PRODUCT_TYPE.CONCENTRATE_LATEX}
    },
    {
      id: 3, 
      label: "3. รายงานการส่งออกน้ำยางข้นประจำเดือน", 
      detail: "รายงานการส่งออกน้ำยางข้นประจำเดือน",
      filters: [
        { name: REPORT_FILTER.MONTH, placeholder: "เดือน", required: true },
        { name: REPORT_FILTER.DELIVERY_SERIAL_ID, placeholder: "Serial ID.", required: false }
      ],
      url: URL_REPORT.DELIVERY_CONCENTRATE_LATEX_MONTHLY,
    },
    {
      id: 4, 
      label: "4. รายงานการส่งออกน้ำยางข้นรายบริษัท", 
      detail: "รายงานการส่งออกน้ำยางข้นรายบริษัท",
      filters: [
        {name: REPORT_FILTER.DATE_RANGE, placeholder: "ช่วงวันที่", required: true},
        {name: REPORT_FILTER.RAW_LATEX_CUSTOMER, placeholder: "ลูกค้า", required: false},
      ],
      url: URL_REPORT.CONCENTRATE_LATEX_DELIVERY,
    },
    {
      id: 5, 
      label: "5. รายงานสั่งซื้อยางสกิม", 
      detail: "รายงานสั่งซื้อยางสกิม",
      filters: [{ name: REPORT_FILTER.TABLE_SALE_ORDER_SKIM, placeholder: "รายการสั่งซื้อน้ำยางข้น", required: true }],
      url: URL_REPORT.SKIM_SALE_ORDER,
      hidePDF : true,
      hideExcel : true,
    },
    {
      id: 6, 
      label: "6. ใบแจ้งการผลิตยางสกิม", 
      detail: "ใบแจ้งการผลิตยางสกิม",
      filters: [
        { name: REPORT_FILTER.DATE, placeholder: "วันที่แจ้งผลิต", required: true },
        { name: REPORT_FILTER.NO, placeholder: "เลขที่", required: false },
      ],
      url: URL_REPORT.PRODUCE_ORDER,
      params: {type : PRODUCT_TYPE.SKIM}
    },
    {
      id: 7, 
      label: "7. รายงานการส่งออกยางสกิมประจำเดือน", 
      detail: "รายงานการส่งออกยางสกิมประจำเดือน",
      filters: [
        { name: REPORT_FILTER.MONTH, placeholder: "เดือน", required: true },
        { name: REPORT_FILTER.DELIVERY_SERIAL_ID, placeholder: "Serial ID", required: false }
      ],
      url: URL_REPORT.DELIVERY_SKIM_MONTHLY,
    },
  ]

  const chemicalReports = [
    {
      id: 1, 
      label: "1. รายงานการรับจ่ายเคมีภัณฑ์", 
      detail: "รายงานการรับจ่ายเคมีภัณฑ์",
      filters: [
        { name: REPORT_FILTER.PURE_CHEMICAL, placeholder: "เคมีภัณฑ์", required: true },
        { name: REPORT_FILTER.DATE_RANGE, placeholder: "เดือน", required: true },
      ],
      url: URL_REPORT.PURE_CHEMICAL_SUMMARY,
    },
    {
      id: 2, 
      label: "2. บันทึกการเบิกเคมีภัณฑ์", 
      detail: "บันทึกการเบิกเคมีภัณฑ์ห้องสโตร์วัสดุ",
      filters: [{ name: REPORT_FILTER.DATE_RANGE, placeholder: "ช่วงวันที่", required: true }],
      url: URL_REPORT.CHEMICAL_USAGE,
      hidePDF: true
    },
    {
      id: 3, 
      label: "3. รายงานปริมาณสารเคมีของผู้ขายน้ำยางสด", 
      detail: "รายงานปริมาณสารเคมีของผู้ขายน้ำยางสด",
      filters: [{ name: REPORT_FILTER.MONTH, placeholder: "เดือน", required: true }],
      url: URL_REPORT.RAW_LATEX_CHEMICAL_AMOUNT,
    },
    // **** ไม่ต้องทำ
    // {
    //   id: 4, 
    //   label: "4. รายงานการจ่าย TZ ต่อน้ำยางสดรายเดือน", 
    //   detail: "รายงานการจ่าย TZ ต่อน้ำยางสดรายเดือน",
    //   filters: [{ name: REPORT_FILTER.MONTH_RANGE, placeholder: "ช่วงเดือน", required: true }],
    //   url: null,
    // },
  ]

  // Render report list
  const renderReportList = (list) => {
    return (
      <Row 
        gutter={[16, 16]}
        style={{marginTop: 16, marginBottom: 16}}>
        {list.map(item => (
          <Col key={item.id} xl={8} sm={12} xs={24}>
            <Button
              style={{width: "100%", justifyContent: "left", borderColor: colorInfoText}}
              disabled={(item && item.url) ? false : true} // disable
              onClick={() => setTargetReport(item)}>
                {item.label}
            </Button>
          </Col>
        ))}
      </Row>
    )
  }

  const manageItems = () => {
    let list = []
    if (!props.disableLatex) {
      list.push({
        key: '1',
        label: 'รายงานข้อมูลน้ำยางสด',
        children: renderReportList(latexReports),
      })
    }
    if (!props.disableConLatex) {
      list.push({
        key: '2',
        label: 'รายงานน้ำยางข้น',
        children: renderReportList(conLatexReports),
      })
    }
    if (!props.disableSkim) {
      list.push({
        key: '3',
        label: 'รายงานสกิม',
        children: renderReportList(skimReports),
      })
    }
    if (!props.disableLab) {
      list.push({
        key: '4',
        label: 'รายงานแลป',
        children: renderReportList(labReports),
      })
    }
    if (!props.disableSale) {
      list.push({
        key: '5',
        label: 'รายงานการขาย',
        children: renderReportList(saleReports),
      })
    }
    if (!props.disableChemical) {
      list.push({
        key: '6',
        label: 'รายงานสารเคมี',
        children: renderReportList(chemicalReports),
      })
    }
    setItems(list)
  }

  React.useEffect(() => {
    manageItems()
  }, [props.disableLatex, props.disableConLatex, props.disableSkim, 
    props.disableLab, props.disableSale, props.disableChemical])

  return(
    <div>
      {targetReport && loading != null &&
				<Modal
          maskClosable={false}
					title={
            <>
              กำลังสร้าง - {targetReport.label}
            </>
          }
					open={loading != null}
					style={{
						top: 20,
					}}
					closable={false}
					footer={[]}>
          <Lottie animationData={lottieReport} />
				</Modal>
			}
      
    <Collapse
      style={{marginTop: 24, justifyContent: "left"}}
      defaultActiveKey={['1', '2', '3', '4', '5', '6']}
      items={items} />

      {/* Modal */}
			<ReportModal
				namePrefix={targetReport ? targetReport.label : null}
				open={targetReport ? true : false}
				data={targetReport}
        target={targetReport}
				onStartLoading={() => setLoading(true)}
				onEndLoading={() => setLoading(null)}
				onClose={() => setTargetReport(null)}/>
    </div> 
  )
}

ReportView.defaultProps = {
  disableLatex: false,
  disableConLatex: false,
  disableSkim: false,
  disableLab: false,
  disableSale: false,
  disableChemical: false,
}

ReportView.propTypes = {
  disableLatex: propTypes.bool,
  disableConLatex: propTypes.bool,
  disableSkim: propTypes.bool,
  disableLab: propTypes.bool,
  disableSale: propTypes.bool,
  disableChemical: propTypes.bool,
}